/**
 * Basis-URL der IONOS-API
 * - Produktion / Build: VITE_API_URL in .env (z. B. https://www.nextgen-web.de/ionos-api)
 * - Entwicklung (localhost): immer /ionos-api via Vite-Proxy (kein CORS im Browser)
 */
const envUrl = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
const isLocalDevHost =
  import.meta.env.DEV &&
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const API_BASE_URL = isLocalDevHost ? '/ionos-api' : (envUrl || '/ionos-api');

export function hasApi() {
  return Boolean(API_BASE_URL && API_BASE_URL.length > 0);
}
